import { Component, ViewChild } from '@angular/core';

import { Job } from './models/job';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JobModalComponent } from './job-modal.component';
import { SortableComponent } from 'ngx-bootstrap/sortable';
import { JobService } from './services/jobs.service';
import { Column } from './models/column';

import * as _ from 'lodash';
import { Subject } from 'rxjs';

import { Debounce } from 'lodash-decorators';
import { ToastrService } from 'ngx-toastr';
import { ConfirmModalComponent } from '../shared/components/confirm-modal.component';

@Component({
  selector: 'job-list',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.css']
})
export class JobListComponent {
  @ViewChild(SortableComponent, { static:false }) sortableComponent: SortableComponent;
  loaded: boolean;

  jobs: Array<Array<any>> = [];
  columns: Array<Column> = [];

  columnChangeSubject: Subject<string>;

  jobModalRef: BsModalRef;
  confirmModalRef: BsModalRef;

  constructor(private modalService: BsModalService, private jobService: JobService, private toastr: ToastrService) {
    this.columns.push({ name: "jobOpenings", title: "Openings", show: true, order: 0, css: 'openings' });
    this.columns.push({ name: "jobApplications", title: "Applications", show: true, order: 1, css: 'applications' });
    this.columns.push({ name: "jobInterviews", title: "Interviews", show: true, order: 2, css: 'interviews' });
    this.columns.push({ name: "jobFollowups", title: "Follow Up", show: true, order: 3, css: 'followup' });
    this.columns.push({ name: "jobArchives", title: "Archive", show: true, order: 4, css: 'archive' });

    console.log(this.columns);
    //Setup column structure
    this.columns.forEach(c => {
      this.jobs.push([c.name, []]);

      this.jobs[c.name] = [];
    });

    console.log(this.jobs);
  }

  ngOnInit() {

    this.loadJobs();

    this.columnChangeSubject = new Subject<string>();

  }


  @Debounce(500)
  listChange(e: any, type: string) {
    

    if (this.loaded) {

      

      var updates = this.jobs[type];

      updates.forEach(f => {

        f.column = type;
        f.index = _.indexOf(this.jobs[type], f);
        
        //Set date if not already set
        if (type == 'jobApplications' && f.applicationDate == null) {
          f.applicationDate = new Date();
        } else if (type == 'jobInterviews' && f.interviewDate == null) {
          f.interviewDate = new Date();
        } else if (type == 'jobFollowups' && f.followUpDate == null) {
          f.followUpDate = new Date();
        } else if (type == 'jobArchives' && f.archiveDate == null) {
          f.archiveDate = new Date();
        }
        

        this.jobService.update(f).subscribe(res => {
          //Save
          //console.log('job saved');
        }, error => {
            console.log("Error updating", error, f);
            this.toastr.error("Error updating job");
        });

      });

      //for debugging
      //this.toastr.success(type + " column updated");

    }
    
  }

  
  loadJobs() {

    this.jobService.get().subscribe(res => {

      //console.log('jobs', res);

      var jobs = res;

      jobs.forEach(job => {        
        if (this.jobs[job.column] == null) {
          this.jobs[job.column] = [];
        }

        this.jobs[job.column].push(job);
      });

      //Set order on columns
      this.columns.forEach(c => {
        this.jobs[c.name] = _.orderBy(this.jobs[c.name], ['index'], ['asc']);
      });
      
      this.loaded = true;      
    });

  }

  addJob() {
    const initialState = {
      mode: 'add',      
    };
    
    this.jobModalRef = this.modalService.show(JobModalComponent, { class: 'modal-xl', ignoreBackdropClick: true, initialState });

    setTimeout(() => { this.resizeParent(); }, 500)
    
    this.jobModalRef.content.onSave.subscribe((job: Job) => {      
      this.jobs[job.column] = [...this.jobs[job.column], job];      
    });
  }

  removeJob(job: Job) {
    //Confirm that we are removing the job
    const initialState = {
      title: job.title,
      //message: "Removing the job will also remove the bookmark to this job."
    };

    this.confirmModalRef = this.modalService.show(ConfirmModalComponent, { ignoreBackdropClick: true, initialState });

    setTimeout(() => { this.resizeParent(); }, 500)


    this.confirmModalRef.content.onClose.subscribe((yesOrNo: boolean) => {

      if (yesOrNo) {
        //remove

        this.jobService.remove(job.id).subscribe(res => { });
        //this.loadJobs();

        this.columns.forEach(c => {

          let index: number = -1;
          index = _.findIndex(this.jobs[c.name], { id: job.id });

          //console.log(c.name, index);

          if (index != -1) {

            //Filter out the removed job
            this.jobs[c.name] = [...this.jobs[c.name].filter(f => f.id !== job.id)];           
          }

        });
      }

    });
  }

  editJob(job: Job) {
    const initialState = {
      mode: 'edit',
      job: job
    };
    this.jobModalRef = this.modalService.show(JobModalComponent, { class: 'modal-xl', ignoreBackdropClick: true, initialState });

    setTimeout(() => { this.resizeParent(); }, 500)

    this.jobModalRef.content.onSave.subscribe((job: Job) => {

      //this.loaded = false;

      //console.log('Save job', job);
      let move: boolean = false;
      let allGood: boolean = false;
      let destColumn: string = job.column;
      let sourceColumn: string = "";

      //find job
      this.columns.forEach(c => {

        let index: number = -1;
        index = _.findIndex(this.jobs[c.name], { id: job.id });

        //console.log(c.name, index);

        if (index != -1 && !allGood) {
          //check to see if we need to move
          allGood = true;
          sourceColumn = c.name;

          this.jobs[sourceColumn] = this.jobs[sourceColumn].filter(f => f.id !== job.id);
          this.jobs[destColumn] = [...this.jobs[destColumn], job];

        }
         
      });

      this.jobModalRef.hide();
    });

  }

  resizeParent() {
    window.dispatchEvent(new Event('resize'));
  }

}
